import {typesShipCli} from './svtypes/cliTypes'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
let initStore = {
    loading: false,
    error: false,
    xxob:{
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "org": "09A",
        "dst": "ADQ"
    },
    my_data_meta:{
            
        "dest": [
            {
                "REGION_ID": 3333,
                "CODE": "SVALL",
                "SHORT_NAME": "Any Destination",
                "LABEL": "Any Destination",
                "ENABLED": 1,
                "PORTSDEST":[{
                    "CODE": "SVALL",
                    "LABEL": "SVALL",
                    "enabled": true
                }]
                
            },
            {
                "REGION_ID": 53,
                "CODE": "ALK",
                "SHORT_NAME": "Alaska",
                "LABEL": "Alaska",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 41,
                        "CODE" : "TFJ",
                        "LABEL" : "Cruise Tracy Arm Fjord",
                        "ENABLED" : 1,
                        "REGION_ID" : 53
                    },
                    {
                        "ID" : 42,
                        "CODE" : "SKY",
                        "LABEL" : "Skagway",
                        "ENABLED" : 1,
                        "REGION_ID" : 53
                    },
                    {
                        "ID" : 43,
                        "CODE" : "JNU",
                        "LABEL" : "Juneau",
                        "ENABLED" : 1,
                        "REGION_ID" : 53
                    },
                    {
                        "ID" : 44,
                        "CODE" : "KTN",
                        "LABEL" : "Ketchikan",
                        "ENABLED" : 1,
                        "REGION_ID" : 53
                    },
                    {
                        "ID" : 45,
                        "CODE" : "YYJ",
                        "LABEL" : "Victoria",
                        "ENABLED" : 1,
                        "REGION_ID" : 53
                    }
                ]
                
               
                
            },
            {
                "REGION_ID": 54,
                "CODE": "BAH",
                "SHORT_NAME": "Bahmas",
                "LABEL": "Bahmas",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 38,
                        "CODE" : "NAS",
                        "LABEL" : "Nassau, Bahamas",
                        "ENABLED" : 1,
                        "REGION_ID" : 54
                    },
                    {
                        "ID" : 52,
                        "CODE" : "FPO",
                        "LABEL" : "New Port",
                        "ENABLED" : 1,
                        "REGION_ID" : 54
                    }
                ]
                
            },
            {
                "REGION_ID": 55,
                "CODE": "HAW",
                "SHORT_NAME": "Hawaii",
                "LABEL": "Hawaii",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 28,
                        "CODE" : "KOA",
                        "LABEL" : "Kona, Hawaii",
                        "ENABLED" : 1,
                        "REGION_ID" : 55
                    },
                    {
                        "ID" : 29,
                        "CODE" : "ITO",
                        "LABEL" : "Hilo, Hawaii",
                        "ENABLED" : 1,
                        "REGION_ID" : 55
                    },
                    {
                        "ID" : 30,
                        "CODE" : "OGG",
                        "LABEL" : "Kahului, Maui",
                        "ENABLED" : 1,
                        "REGION_ID" : 55
                    },
                    {
                        "ID" : 31,
                        "CODE" : "HNL",
                        "LABEL" : "Honolulu Harbor,Hawaii",
                        "ENABLED" : 1,
                        "REGION_ID" : 55
                    },
                    {
                        "ID" : 40,
                        "CODE" : "NWK",
                        "LABEL" : "Nāwiliwili, Kaua",
                        "ENABLED" : 1,
                        "REGION_ID" : 55
                    }
                ]
                
            },
            {
                "REGION_ID": 56,
                "CODE": "CAN",
                "SHORT_NAME": "Canada,England",
                "LABEL": "Canada & New England",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 14,
                        "CODE" : "NYC",
                        "LABEL" : "Manhattan, New York City, NY",
                        "ENABLED" : 1,
                        "REGION_ID" : 56
                    },
                    {
                        "ID" : 53,
                        "CODE" : "BHB",
                        "LABEL" : "Bar Harbor",
                        "ENABLED" : 1,
                        "REGION_ID" : 56
                    },
                    {
                        "ID" : 54,
                        "CODE" : "PVD",
                        "LABEL" : "New Port, Rhode",
                        "ENABLED" : 1,
                        "REGION_ID" : 56
                    },
                    {
                        "ID" : 55,
                        "CODE" : "BOS",
                        "LABEL" : "BOSTON",
                        "ENABLED" : 1,
                        "REGION_ID" : 56
                    },
                    {
                        "ID" : 56,
                        "CODE" : "BDL",
                        "LABEL" : "New Haven",
                        "ENABLED" : 1,
                        "REGION_ID" : 56
                    },
                    {
                        "ID" : 57,
                        "CODE" : "YHZ",
                        "LABEL" : "Halifax",
                        "ENABLED" : 1,
                        "REGION_ID" : 56
                    }
                ]
                
            },
            {
                "REGION_ID": 57,
                "CODE": "CAR",
                "SHORT_NAME": "Carribean",
                "LABEL": "Carribean",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 17,
                        "CODE" : "MOB",
                        "LABEL" : "Mobile, AL",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 32,
                        "CODE" : "POP",
                        "LABEL" : "Puerto Plata, Dominican Republic",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 33,
                        "CODE" : "STT",
                        "LABEL" : "St. Thomas, US Virgin Islands",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 34,
                        "CODE" : "TOV",
                        "LABEL" : "Tortola, British Virgin Islands",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 35,
                        "CODE" : "NPI",
                        "LABEL" : "Great Stirrup Cay, Bahamas",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 36,
                        "CODE" : "CZM",
                        "LABEL" : "Cozumel, Mexico",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 37,
                        "CODE" : "RTB",
                        "LABEL" : "Roatan (Bay Islands), Honduras",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 46,
                        "CODE" : "BPI",
                        "LABEL" : "Harvest Caye, Belize",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    },
                    {
                        "ID" : 47,
                        "CODE" : "CMA",
                        "LABEL" : "Costa Maya, Mexico",
                        "ENABLED" : 1,
                        "REGION_ID" : 57
                    }
                ]
                
                
            },
            {
                "REGION_ID": 58,
                "CODE": "EUR",
                "SHORT_NAME": "Europe",
                "LABEL": "Europe",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 4,
                        "CODE" : "BCN",
                        "LABEL" : "Barcelona, Spain",
                        "ENABLED" : 1,
                        "REGION_ID" : 58
                    },
                    {
                        "ID" : 7,
                        "CODE" : "CIV",
                        "LABEL" : "Civitavecchia (Rome), Italy",
                        "ENABLED" : 1,
                        "REGION_ID" : 58
                    },
                    {
                        "ID" : 11,
                        "CODE" : "LIS",
                        "LABEL" : "Lisbon, Portugal",
                        "ENABLED" : 1,
                        "REGION_ID" : 58
                    },
                    {
                        "ID" : 12,
                        "CODE" : "LON",
                        "LABEL" : "London, England",
                        "ENABLED" : 1,
                        "REGION_ID" : 58
                    }
                ]
                
            },
            {
                "REGION_ID": 59,
                "CODE": "MEX",
                "SHORT_NAME": "Mexico",
                "LABEL": "Mexico",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 49,
                        "CODE" : "PVR",
                        "LABEL" : "Puerto Vallarta, Mexico",
                        "ENABLED" : 1,
                        "REGION_ID" : 59
                    },
                    {
                        "ID" : 50,
                        "CODE" : "MZT",
                        "LABEL" : "Mazatlan, Mexico",
                        "ENABLED" : 1,
                        "REGION_ID" : 59
                    },
                    {
                        "ID" : 51,
                        "CODE" : "CSL",
                        "LABEL" : "Cabo San Lucas, Mexico",
                        "ENABLED" : 1,
                        "REGION_ID" : 59
                    }
                ]
                
            },
            {
                "REGION_ID": 60,
                "CODE": "PAN",
                "SHORT_NAME": "Panama Canal",
                "LABEL": "Panama Canal",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 60,
                        "CODE" : "PTY",
                        "LABEL" : "Balboa",
                        "ENABLED" : 1,
                        "REGION_ID" : 60
                    }
                ]
                
            },
            {
                "REGION_ID": 61,
                "CODE": "SAM",
                "SHORT_NAME": "South America",
                "LABEL": "South America",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 6,
                        "CODE" : "BUE",
                        "LABEL" : "Buenos Aires, Argentina",
                        "ENABLED" : 1,
                        "REGION_ID" : 61
                    },
                    {
                        "ID" : 61,
                        "CODE" : "GIG",
                        "LABEL" : "Rio de Janeiro",
                        "ENABLED" : 1,
                        "REGION_ID" : 61
                    },
                    {
                        "ID" : 62,
                        "CODE" : "EZE",
                        "LABEL" : "Buenos Aires",
                        "ENABLED" : 1,
                        "REGION_ID" : 61
                    }
                ]
                
            },
            {
                "REGION_ID": 62,
                "CODE": "TRA",
                "SHORT_NAME": "Transpacific",
                "LABEL": "Transpacific",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 9,
                        "CODE" : "HKG",
                        "LABEL" : "Hong Kong",
                        "ENABLED" : 1,
                        "REGION_ID" : 62
                    },
                    {
                        "ID" : 21,
                        "CODE" : "SAI",
                        "LABEL" : "San Antonio (Santiago), Chile",
                        "ENABLED" : 1,
                        "REGION_ID" : 62
                    },
                    {
                        "ID" : 22,
                        "CODE" : "SFO",
                        "LABEL" : "San Francisco, CA",
                        "ENABLED" : 1,
                        "REGION_ID" : 62
                    },
                    {
                        "ID" : 23,
                        "CODE" : "SEA",
                        "LABEL" : "Seattle, WA",
                        "ENABLED" : 1,
                        "REGION_ID" : 62
                    },
                    {
                        "ID" : 24,
                        "CODE" : "SIN",
                        "LABEL" : "Singapore",
                        "ENABLED" : 1,
                        "REGION_ID" : 62
                    },
                    {
                        "ID" : 27,
                        "CODE" : "TYO",
                        "LABEL" : "Tokyo, Japan",
                        "ENABLED" : 1,
                        "REGION_ID" : 62
                    }
                ]
                
            },
            {
                "REGION_ID": 63,
                "CODE": "AUS",
                "SHORT_NAME": "Australia",
                "LABEL": "Australia",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 1,
                        "CODE" : "ADL",
                        "LABEL" : "Adelaide, Australia",
                        "ENABLED" : 0,
                        "REGION_ID" : 63
                    },
                    {
                        "ID" : 5,
                        "CODE" : "BNE",
                        "LABEL" : "Brisbane, Australia",
                        "ENABLED" : 1,
                        "REGION_ID" : 63
                    },
                    {
                        "ID" : 15,
                        "CODE" : "MEL",
                        "LABEL" : "Melbourne, Australia",
                        "ENABLED" : 1,
                        "REGION_ID" : 63
                    },
                    {
                        "ID" : 25,
                        "CODE" : "SYD",
                        "LABEL" : "Sydney, Australia",
                        "ENABLED" : 1,
                        "REGION_ID" : 63
                    }
                ]
                
            },
            {
                "REGION_ID": 64,
                "CODE": "NZW",
                "SHORT_NAME": "New Zealan",
                "LABEL": "New Zealan",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 2,
                        "CODE" : "AKL",
                        "LABEL" : "Auckland, New Zealand",
                        "ENABLED" : 1,
                        "REGION_ID" : 64
                    }
                ]
                
            },
            {
                "REGION_ID": 65,
                "CODE": "SPA",
                "SHORT_NAME": "South Pacific",
                "LABEL": "South Pacific",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 59,
                        "CODE" : "VLI",
                        "LABEL" : "Port Vila",
                        "ENABLED" : 1,
                        "REGION_ID" : 65
                    }
                ]
                
            },
            {
                "REGION_ID": 66,
                "CODE": "KEY",
                "SHORT_NAME": "Celebration Key",
                "LABEL": "Celebration Key",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 38,
                        "CODE" : "NAS",
                        "LABEL" : "Nassau, Bahamas",
                        "ENABLED" : 1,
                        "REGION_ID" : 66
                    }
                ]
                
            },
            {
                "REGION_ID": 67,
                "CODE": "ROA",
                "SHORT_NAME": "Tropicane Roatan",
                "LABEL": "Isla Tropicane, Roatan",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 37,
                        "CODE" : "RTB",
                        "LABEL" : "Roatán (Bay Islands), Honduras",
                        "ENABLED" : 1,
                        "REGION_ID" : 67
                    }
                ]
                
            },
            {
                "REGION_ID": 68,
                "CODE": "CAY",
                "SHORT_NAME": "Half Moon Cay",
                "LABEL": "RelaxAway Half Moon Cay",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 52,
                        "CODE" : "FPO",
                        "LABEL" : "Great Stirrup Cay, Bahmas",
                        "ENABLED" : 1,
                        "REGION_ID" : 68
                    }
                ]
                
            },
            {
                "REGION_ID": 69,
                "CODE": "BER",
                "SHORT_NAME": "Bermuda",
                "LABEL": "Bermuda",
                "ENABLED": 1,
                "PORTSDEST":[
                    {
                        "ID" : 58,
                        "CODE" : "BDA",
                        "LABEL" : "Royal Naval Dockyard,Bermuda",
                        "ENABLED" : 1,
                        "REGION_ID" : 69
                    }
                ]
                
            }
        ],
        "portCall": [
            {
                "code": "ALL",
                "label": "All Ports",
                "enabled": false
            },
            {
                "code": "ADL",
                "label": "Adelaide, Australia",
                "enabled": false
            },
            {
                "code": "AKL",
                "label": "Auckland, New Zealand",
                "enabled": false
            },
            {
                "code": "BWI",
                "label": "Baltimore, MD",
                "enabled": false
            },
            {
                "code": "BCN",
                "label": "Barcelona, Spain",
                "enabled": false
            },
            {
                "code": "BNE",
                "label": "Brisbane, Australia",
                "enabled": false
            },
            {
                "code": "BUE",
                "label": "Buenos Aires, Argentina",
                "enabled": false
            },
            {
                "code": "CIV",
                "label": "Civitavecchia (Rome), Italy",
                "enabled": false
            },
            {
                "code": "GAL",
                "label": "Galveston, TX",
                "enabled": false
            },
            {
                "code": "HKG",
                "label": "Hong Kong\n\n\n",
                "enabled": false
            },
            {
                "code": "JAX",
                "label": "Jacksonville, FL",
                "enabled": false
            },
            {
                "code": "LIS",
                "label": "Lisbon, Portugal",
                "enabled": false
            },
            {
                "code": "LON",
                "label": "London, England",
                "enabled": false
            },
            {
                "code": "LAX",
                "label": "Los Angeles, CA",
                "enabled": false
            },
            {
                "code": "NYC",
                "label": "Manhattan, New York City, NY",
                "enabled": false
            },
            {
                "code": "MEL",
                "label": "Melbourne, Australia",
                "enabled": false
            },
            {
                "code": "MIA",
                "label": "Miami, FL",
                "enabled": false
            },
            {
                "code": "MOB",
                "label": "Mobile, AL",
                "enabled": false
            },
            {
                "code": "MSY",
                "label": "New Orleans, LA",
                "enabled": false
            },
            {
                "code": "ORF",
                "label": "Norfolk, VA",
                "enabled": false
            },
            {
                "code": "PCV",
                "label": "Port Canaveral (Orlando), FL",
                "enabled": false
            },
            {
                "code": "SAI",
                "label": "San Antonio (Santiago), Chile",
                "enabled": false
            },
            {
                "code": "SFO",
                "label": "San Francisco, CA",
                "enabled": false
            },
            {
                "code": "SEA",
                "label": "Seattle, WA",
                "enabled": true
            },
            {
                "code": "SIN",
                "label": "Singapore",
                "enabled": false
            },
            {
                "code": "SYD",
                "label": "Sydney, Australia",
                "enabled": false
            },
            {
                "code": "TPA",
                "label": "Tampa, FL",
                "enabled": false
            },
            {
                "code": "TYO",
                "label": "Tokyo, Japan",
                "enabled": false
            }
        ],
        "port": [
            {
                "code": "SVALL",
                "label": "Any Port",
                "enabled": true
            },
            {
                "code": "ADL",
                "label": "Adelaide, Australia",
                "enabled": false
            },
            {
                "code": "AKL",
                "label": "Auckland, New Zealand",
                "enabled": false
            },
            {
                "code": "BWI",
                "label": "Baltimore, MD",
                "enabled": false
            },
            {
                "code": "BCN",
                "label": "Barcelona, Spain",
                "enabled": false
            },
            {
                "code": "BNE",
                "label": "Brisbane, Australia",
                "enabled": false
            },
            {
                "code": "BUE",
                "label": "Buenos Aires, Argentina",
                "enabled": false
            },
            {
                "code": "CIV",
                "label": "Civitavecchia (Rome), Italy",
                "enabled": false
            },
            {
                "code": "GAL",
                "label": "Galveston, TX",
                "enabled": false
            },
            {
                "code": "HKG",
                "label": "Hong Kong\n\n\n",
                "enabled": false
            },
            {
                "code": "JAX",
                "label": "Jacksonville, FL",
                "enabled": false
            },
            {
                "code": "LIS",
                "label": "Lisbon, Portugal",
                "enabled": false
            },
            {
                "code": "LON",
                "label": "London, England",
                "enabled": false
            },
            {
                "code": "LAX",
                "label": "Los Angeles, CA",
                "enabled": false
            },
            {
                "code": "NYC",
                "label": "Manhattan, New York City, NY",
                "enabled": false
            },
            {
                "code": "MEL",
                "label": "Melbourne, Australia",
                "enabled": false
            },
            {
                "code": "MIA",
                "label": "Miami, FL",
                "enabled": false
            },
            {
                "code": "MOB",
                "label": "Mobile, AL",
                "enabled": false
            },
            {
                "code": "MSY",
                "label": "New Orleans, LA",
                "enabled": false
            },
            {
                "code": "ORF",
                "label": "Norfolk, VA",
                "enabled": false
            },
            {
                "code": "PCV",
                "label": "Port Canaveral (Orlando), FL",
                "enabled": false
            },
            {
                "code": "SAI",
                "label": "San Antonio (Santiago), Chile",
                "enabled": false
            },
            {
                "code": "SFO",
                "label": "San Francisco, CA",
                "enabled": false
            },
            {
                "code": "SEA",
                "label": "Seattle, WA",
                "enabled": true
            },
            {
                "code": "SIN",
                "label": "Singapore",
                "enabled": false
            },
            {
                "code": "SYD",
                "label": "Sydney, Australia",
                "enabled": false
            },
            {
                "code": "TPA",
                "label": "Tampa, FL",
                "enabled": false
            },
            {
                "code": "TYO",
                "label": "Tokyo, Japan",
                "enabled": false
            }
        ],
        "cabin":[{
            "id": 1,
            "label": "BALCONY",
            "brand_id" : 1,
            "enabled": false,
        },{
            "id": 2,
            "label": "INTERIOR",
            "brand_id" : 1,
            "enabled": false,
        },{
            "id": 3,
            "label": "OCEAN VIEW",
            "brand_id" : 1,
            "enabled": false,
        },{
            "id": 4,
            "label": "SUITE",
            "brand_id" : 1,
            "enabled": false,
        },{
            "id": 5,
            "label": "MSC YACHT CLUB",
            "brand_id" : 2,
            "enabled": false,
        }],
        "durDays": [
            {
                "code": "2",
                "label": "2 Days",
                "enabled": false
            },
            {
                "code": "3",
                "label": "3 Days",
                "enabled": false
            },
            {
                "code": "4",
                "label": "4 Days",
                "enabled": false
            },
            {
                "code": "5",
                "label": "5 Days",
                "enabled": false
            },
            {
                "code": "6",
                "label": "6 Days",
                "enabled": false
            },
            {
                "code": "7",
                "label": "7 Days",
                "enabled": true
            },
            {
                "code": "8",
                "label": "8 Days",
                "enabled": false
            },
            {
                "code": "9",
                "label": "9 Days",
                "enabled": false
            },
            {
                "code": "10",
                "label": "10 Days",
                "enabled": false
            },
            {
                "code": "11",
                "label": "11 Days",
                "enabled": false
            },
            {
                "code": "12",
                "label": "12 Days",
                "enabled": false
            },
            {
                "code": "13",
                "label": "13 Days",
                "enabled": false
            },
            {
                "code": "14",
                "label": "14 Days",
                "enabled": false
            },
            {
                "code": "15",
                "label": "15 Days",
                "enabled": false
            },
            {
                "code": "16",
                "label": "16 Days",
                "enabled": false
            },
            {
                "code": "22",
                "label": "22 Days",
                "enabled": false
            },
            {
                "code": "23",
                "label": "23 Days",
                "enabled": false
            }
        ],
        "dur": [
            {
                "code": "SVALL",
                "label": "All Durations",
                "enabled": true
            },
            {
                "code": "D1",
                "label": "2 - 5 Days",
                "enabled": false
            },
            {
                "code": "D2",
                "label": "6 - 9 Days",
                "enabled": true
            },
            {
                "code": "D3",
                "label": "10+ Days",
                "enabled": false
            }
        ],
        "datFrom": [
            {
                "code": "122025",
                "label": "Dec 2025",
                "enabled": false
            },
            {
                "code": "012026",
                "label": "Jan 2026",
                "enabled": false
            },
            {
                "code": "022026",
                "label": "Feb 2026",
                "enabled": false
            },
            {
                "code": "032026",
                "label": "Mar 2026",
                "enabled": false
            },
            {
                "code": "042026",
                "label": "Apr 2026",
                "enabled": true
            },
            {
                "code": "052026",
                "label": "May 2026",
                "enabled": true
            },
            {
                "code": "062026",
                "label": "Jun 2026",
                "enabled": true
            },
            {
                "code": "072026",
                "label": "Jul 2026",
                "enabled": true
            },
            {
                "code": "082026",
                "label": "Aug 2026",
                "enabled": true
            },
            {
                "code": "092026",
                "label": "Sep 2026",
                "enabled": true
            },
            {
                "code": "102026",
                "label": "Oct 2026",
                "enabled": false
            },
            {
                "code": "112026",
                "label": "Nov 2026",
                "enabled": false
            },
            {
                "code": "122026",
                "label": "Dec 2026",
                "enabled": false
            },
            {
                "code": "012027",
                "label": "Jan 2027",
                "enabled": false
            },
            {
                "code": "022027",
                "label": "Feb 2027",
                "enabled": false
            },
            {
                "code": "032027",
                "label": "Mar 2027",
                "enabled": false
            },
            {
                "code": "042027",
                "label": "Apr 2027",
                "enabled": true
            },
            {
                "code": "052027",
                "label": "May 2027",
                "enabled": true
            },
            {
                "code": "062027",
                "label": "Jun 2027",
                "enabled": true
            },
            {
                "code": "072027",
                "label": "Jul 2027",
                "enabled": true
            },
            {
                "code": "082027",
                "label": "Aug 2027",
                "enabled": true
            },
            {
                "code": "092027",
                "label": "Sep 2027",
                "enabled": true
            },
            {
                "code": "102027",
                "label": "Oct 2027",
                "enabled": false
            },
            {
                "code": "112027",
                "label": "Nov 2027",
                "enabled": false
            },
            {
                "code": "122027",
                "label": "Dec 2027",
                "enabled": false
            },
            {
                "code": "012028",
                "label": "Jan 2028",
                "enabled": false
            },
            {
                "code": "022028",
                "label": "Feb 2028",
                "enabled": false
            },
            {
                "code": "032028",
                "label": "Mar 2028",
                "enabled": false
            },
            {
                "code": "042028",
                "label": "Apr 2028",
                "enabled": false
            },
            {
                "code": "052028",
                "label": "May 2028",
                "enabled": false
            },
            {
                "code": "062028",
                "label": "Jun 2028",
                "enabled": false
            },
            {
                "code": "072028",
                "label": "Jul 2028",
                "enabled": false
            }
        ],
        "shipCode": [
            {
                "code": "SVALL",
                "label": "All Ships",
                "enabled": true
            },
            {
                "code": "AQ",
                "label": "Carnival Adventure",
                "enabled": false
            },
            {
                "code": "BR",
                "label": "Carnival Breeze",
                "enabled": false
            },
            {
                "code": "CB",
                "label": "Carnival Celebration",
                "enabled": false
            },
            {
                "code": "CQ",
                "label": "Carnival Conquest",
                "enabled": false
            },
            {
                "code": "DR",
                "label": "Carnival Dream",
                "enabled": false
            },
            {
                "code": "EL",
                "label": "Carnival Elation",
                "enabled": false
            },
            {
                "code": "EQ",
                "label": "Carnival Encounter",
                "enabled": false
            },
            {
                "code": "FT",
                "label": "Carnival Festivale",
                "enabled": false
            },
            {
                "code": "FN",
                "label": "Carnival Firenze",
                "enabled": false
            },
            {
                "code": "FD",
                "label": "Carnival Freedom",
                "enabled": false
            },
            {
                "code": "GL",
                "label": "Carnival Glory",
                "enabled": false
            },
            {
                "code": "HZ",
                "label": "Carnival Horizon",
                "enabled": false
            },
            {
                "code": "JB",
                "label": "Carnival Jubilee",
                "enabled": false
            },
            {
                "code": "LE",
                "label": "Carnival Legend",
                "enabled": false
            },
            {
                "code": "LI",
                "label": "Carnival Liberty",
                "enabled": false
            },
            {
                "code": "LM",
                "label": "Carnival Luminosa",
                "enabled": false
            },
            {
                "code": "MC",
                "label": "Carnival Magic",
                "enabled": false
            },
            {
                "code": "MI",
                "label": "Carnival Miracle",
                "enabled": true
            },
            {
                "code": "PO",
                "label": "Carnival Panorama",
                "enabled": false
            },
            {
                "code": "PA",
                "label": "Carnival Paradise",
                "enabled": false
            },
            {
                "code": "PR",
                "label": "Carnival Pride",
                "enabled": false
            },
            {
                "code": "RD",
                "label": "Carnival Radiance",
                "enabled": false
            },
            {
                "code": "SP",
                "label": "Carnival Spirit",
                "enabled": true
            },
            {
                "code": "SL",
                "label": "Carnival Splendor",
                "enabled": false
            },
            {
                "code": "SN",
                "label": "Carnival Sunrise",
                "enabled": false
            },
            {
                "code": "SH",
                "label": "Carnival Sunshine",
                "enabled": false
            },
            {
                "code": "VA",
                "label": "Carnival Valor",
                "enabled": false
            },
            {
                "code": "VX",
                "label": "Carnival Venezia",
                "enabled": false
            },
            {
                "code": "VS",
                "label": "Carnival Vista",
                "enabled": false
            },
            {
                "code": "MD",
                "label": "Mardi Gras",
                "enabled": false
            }
        ],
        "specials": [
            {
                "code": "J",
                "label": "Carnival Journeys",
                "enabled": false
            },
            {
                "code": "USA250",
                "label": "America's 250th Birthday",
                "enabled": false
            },
            {
                "code": "CARNIVAL55",
                "label": "Carnival's 55th Birthday",
                "enabled": false
            },
            {
                "code": "ECLIPSE",
                "label": "Solar Eclipse Cruising",
                "enabled": false
            }
        ],
        "svbrand":[
            {
                "code": "SVALL",
                "label": "All Cruises",
                "enabled": true
            },
            {
                "code": "RCCL",
                "label": "RoyalCarribean,Celebrity,SeverSeas",
                "enabled": true
            },
            {
                "code": "MSC",
                "label": "MSC Cruises",
                "enabled": true
            },
            {
                "code": "CARN",
                "label": "Carnival Cruises",
                "enabled": true
            }
        ],
        
        
        
        svpageSize:5
        

    },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    svcli_esquery_data : {
       
       
       
        escountryOrg:"LAX",
        escountryDst:"A",
        my_orgqueryText: "xx",
        my_dstqueryText: "yy",
        STARTDATE:"2025-11-25",
        ENDDATE: "2025-11-27",
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "Asia/Kolkata",


        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esquerySpecials:"J",
        esqueryTripType:"roundtrip",
        esqueryPortcall : "LAX",
        esqueryShip : "AQ",
        esqueryDur : "D1",
        esquerySailto:['Miamu'],
        svpageSize:5
         /*arilines end */

    },
    "svselected": {
        "dest": [
            {
                "code": "A",
                "label": "Alaska",
                "enabled": true
            },
            {
                "code": "BH",
                "label": "The Bahamas",
                "enabled": false
            },
            {
                "code": "BM",
                "label": "Bermuda",
                "enabled": false
            },
            {
                "code": "NN",
                "label": "Canada & New England",
                "enabled": false
            },
            {
                "code": "C",
                "label": "Caribbean",
                "enabled": false
            },
            {
                "code": "E",
                "label": "Europe",
                "enabled": false
            },
            {
                "code": "GC",
                "label": "Greenland & Canada",
                "enabled": false
            },
            {
                "code": "H",
                "label": "Hawaii",
                "enabled": false
            },
            {
                "code": "M",
                "label": "Mexico",
                "enabled": false
            },
            {
                "code": "T",
                "label": "Panama Canal",
                "enabled": false
            },
            {
                "code": "S",
                "label": "South America",
                "enabled": false
            },
            {
                "code": "ET",
                "label": "Transatlantic",
                "enabled": false
            },
            {
                "code": "TP",
                "label": "Transpacific",
                "enabled": false
            },
            {
                "code": "X",
                "label": "Asia",
                "enabled": false
            },
            {
                "code": "U",
                "label": "Australia",
                "enabled": false
            },
            {
                "code": "NZ",
                "label": "New Zealand",
                "enabled": false
            },
            {
                "code": "O",
                "label": "South Pacific",
                "enabled": false
            },
            {
                "code": "CBK",
                "label": "Celebration Key™",
                "enabled": false
            },
            {
                "code": "RTB",
                "label": "Isla Tropicale, Roatan",
                "enabled": false
            },
            {
                "code": "HMD",
                "label": "RelaxAway, Half Moon Cay™",
                "enabled": false
            }
        ],
        "port": [
            {
                "code": "ADL",
                "label": "Adelaide, Australia",
                "enabled": false
            },
            {
                "code": "AKL",
                "label": "Auckland, New Zealand",
                "enabled": false
            },
            {
                "code": "BWI",
                "label": "Baltimore, MD",
                "enabled": false
            },
            {
                "code": "BCN",
                "label": "Barcelona, Spain",
                "enabled": false
            },
            {
                "code": "BNE",
                "label": "Brisbane, Australia",
                "enabled": false
            },
            {
                "code": "BUE",
                "label": "Buenos Aires, Argentina",
                "enabled": false
            },
            {
                "code": "CIV",
                "label": "Civitavecchia (Rome), Italy",
                "enabled": false
            },
            {
                "code": "GAL",
                "label": "Galveston, TX",
                "enabled": false
            },
            {
                "code": "HKG",
                "label": "Hong Kong\n\n\n",
                "enabled": false
            },
            {
                "code": "JAX",
                "label": "Jacksonville, FL",
                "enabled": false
            },
            {
                "code": "LIS",
                "label": "Lisbon, Portugal",
                "enabled": false
            },
            {
                "code": "LON",
                "label": "London, England",
                "enabled": false
            },
            {
                "code": "LAX",
                "label": "Los Angeles, CA",
                "enabled": false
            },
            {
                "code": "NYC",
                "label": "Manhattan, New York City, NY",
                "enabled": false
            },
            {
                "code": "MEL",
                "label": "Melbourne, Australia",
                "enabled": false
            },
            {
                "code": "MIA",
                "label": "Miami, FL",
                "enabled": false
            },
            {
                "code": "MOB",
                "label": "Mobile, AL",
                "enabled": false
            },
            {
                "code": "MSY",
                "label": "New Orleans, LA",
                "enabled": false
            },
            {
                "code": "ORF",
                "label": "Norfolk, VA",
                "enabled": false
            },
            {
                "code": "PCV",
                "label": "Port Canaveral (Orlando), FL",
                "enabled": false
            },
            {
                "code": "SAI",
                "label": "San Antonio (Santiago), Chile",
                "enabled": false
            },
            {
                "code": "SFO",
                "label": "San Francisco, CA",
                "enabled": false
            },
            {
                "code": "SEA",
                "label": "Seattle, WA",
                "enabled": true
            },
            {
                "code": "SIN",
                "label": "Singapore",
                "enabled": false
            },
            {
                "code": "SYD",
                "label": "Sydney, Australia",
                "enabled": false
            },
            {
                "code": "TPA",
                "label": "Tampa, FL",
                "enabled": false
            },
            {
                "code": "TYO",
                "label": "Tokyo, Japan",
                "enabled": false
            }
        ],
        "durDays": [
            {
                "code": "2",
                "label": "2 Days",
                "enabled": false
            },
            {
                "code": "3",
                "label": "3 Days",
                "enabled": false
            }
            
        ],
        "dur": [
            {
                "code": "D1",
                "label": "2 - 5 Days",
                "enabled": false
            },
            {
                "code": "D2",
                "label": "6 - 9 Days",
                "enabled": true
            }
        ],
        "datFrom": [
            {
                "code": "122025",
                "label": "Dec 2025",
                "enabled": false
            },
            {
                "code": "012026",
                "label": "Jan 2026",
                "enabled": false
            },
            {
                "code": "022026",
                "label": "Feb 2026",
                "enabled": false
            }
        ],
        "shipCode": [
            {
                "code": "AQ",
                "label": "Carnival Adventure",
                "enabled": false
            },
            {
                "code": "BR",
                "label": "Carnival Breeze",
                "enabled": false
            }
            
        ],
        "specials": [
            {
                "code": "J",
                "label": "Carnival Journeys",
                "enabled": false
            }
           
        ],
        "ptPort": [],
        "dateRanges": [],
        "ev": [],
        "itineraryCheapestPrices": [],
        "minPriceByOffer": [],
        "minPrice": 0,
        "maxPrice": 0
    },

    crudoffer_flag: 'I',

    my_data_svtoffee:{
        "customerId": 7,
        "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
        "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
    },
    //mcicountryDst
    my_esqueryText : "mexco",
    radio_data: [
        
        {
            "name": "3",
            "id": 3,
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "4",
            "id": 4,
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ],
    
    svr_soj_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    hasMore:true,
    ctotal:3,
    my_scr_id:"AAluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR",
    my_data : [],
    my_data_long:[
        {
            "code": "MI",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-14T00:00:00.000Z",
                "arrivalDayOfWeek": "Thu",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-07T00:00:00.000Z",
                "departureDayOfWeek": "Thu",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 0,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_SP_6_Mon",
            "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": true,
            "sailings": null,
            "shipCode": "MI",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        },
        {
            "code": "SP",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-12T00:00:00.000Z",
                "arrivalDayOfWeek": "Tue",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-05T00:00:00.000Z",
                "departureDayOfWeek": "Tue",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 809,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_SP_7_Tue_ols",
            "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalSpirit&format=image",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/spirit/7-days/ga2?itinportcode=SEA&sailDate=05052026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": false,
            "sailings": null,
            "shipCode": "SP",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        },
        {
            "code": "MI",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-14T00:00:00.000Z",
                "arrivalDayOfWeek": "Thu",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-07T00:00:00.000Z",
                "departureDayOfWeek": "Thu",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 829,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_MI_7_Thu",
            "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalMiracle&format=image",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&sailDate=05072026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": false,
            "sailings": null,
            "shipCode": "MI",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        },
        {
            "code": "SP",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-12T00:00:00.000Z",
                "arrivalDayOfWeek": "Tue",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-05T00:00:00.000Z",
                "departureDayOfWeek": "Tue",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 809,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_SP_7_Tue",
            "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalSpirit&format=image",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/spirit/7-days/ga2?itinportcode=SEA&sailDate=05052026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": false,
            "sailings": null,
            "shipCode": "SP",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        },
        {
            "code": "MI",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-14T00:00:00.000Z",
                "arrivalDayOfWeek": "Thu",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-07T00:00:00.000Z",
                "departureDayOfWeek": "Thu",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 829,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_MI_7_Thu",
            "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalMiracle&format=image",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&sailDate=05072026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": false,
            "sailings": null,
            "shipCode": "MI",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        },
        {
            "code": "MI",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-14T00:00:00.000Z",
                "arrivalDayOfWeek": "Thu",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-07T00:00:00.000Z",
                "departureDayOfWeek": "Thu",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 0,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_SP_7_Tue_HW",
            "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": true,
            "sailings": null,
            "shipCode": "MI",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        },
        {
            "code": "MI",
            "departurePortCode": "SEA",
            "departurePortName": "Seattle, WA",
            "dur": 7,
            "duration": null,
            "exTrip": {
                "arrivalDate": "2026-05-14T00:00:00.000Z",
                "arrivalDayOfWeek": "Thu",
                "arrivalDayOfWeekFull": null,
                "arrivalMmmDYyyy": null,
                "arrivalMmmDdYyyy": null,
                "departureDate": "2026-05-07T00:00:00.000Z",
                "departureDayOfWeek": "Thu",
                "departureDayOfWeekFull": null,
                "departureMmmDYyyy": null,
                "departureMmmDdYyyy": null,
                "embarkPortCode": "SEA",
                "exSchedule": null,
                "fromPrice": 0,
                "fromPriceCurrency": "USD",
                "leadMetaCode": "IS",
                "taxesAndFees": 0
            },
            "hasExtraValue": true,
            "id": "GA2_SEA_SP_6_Mon_HW",
            "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
            "imageRandomizationInfo": null,
            "imageSquare": null,
            "imageUrl": null,
            "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
            "itineraryTitleFormatted": null,
            "itineraryURL": null,
            "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
            "portsToDisplay": null,
            "regionCode": "GL",
            "regionName": null,
            "roundtrip": true,
            "sailings": null,
            "shipCode": "MI",
            "shipName": null,
            "specialScoops": null,
            "stateroomMetaInformation": null,
            "taxesAndFeesRange": null
        }
    ]
}



export default (state = initStore, action) => {
    console.log(action)
    let januState, svns
    switch (action.type) {
        case "sojourns/LIST_ITINS":

     console.log('tasks LIST_ITINS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case "SVFINDFILTERS_CLI_SUCCESS":
            console.log("SV MAr6** SVFINDFILTERS_SUCCESS");
            console.log(action.payload.svfly_esquery_data);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state,  error: false, loading: false, svfly_esquery_data: action.payload.svfly_esquery_data}
            return januState
        case "GET_SHIP_CLI_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg MAR6**8reducer  success*****************");
            console.log(action.payload.my_data);
            let sj_scr_id=action.payload.my_scr_id ? action.payload.my_scr_id  : ''
            let n_total = action.payload.my_data ? action.payload.my_data.length : 0
            let ps = state.ctotal
            let sj_total = ps + n_total
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            if(action.payload.svcli_esquery_data){
                januState = {...state, error: false, loading: false, ctotal:sj_total,  my_scr_id:sj_scr_id,my_data: action.payload.my_data, my_data_geo: action.payload.my_data_geo, svr_soj_images: action.payload.my_images, svselected:action.payload.svcli_esquery_data}
  
            
            }else{
                januState = {...state,  error: false,loading: false, ctotal:sj_total,  my_scr_id:sj_scr_id,my_data: action.payload.my_data,my_data_geo: action.payload.my_data_geo, svr_soj_images: action.payload.my_images}
  
            
            }
            /*
            if(action.payload.svcli_esquery_data){
                januState = {...state, error: false, loading: false, my_data: action.payload.my_data, my_data_geo: action.payload.my_data_geo, svr_soj_images: action.payload.my_images, svselected:action.payload.svcli_esquery_data}
  
            
            }else{
                januState = {...state,  error: false,loading: false, my_data: action.payload.my_data,my_data_geo: action.payload.my_data_geo, svr_soj_images: action.payload.my_images}
  
            
            }
            */
                       return januState
        case "radio-success":
                console.log("radio success");
                console.log(action.payload.my_data);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                 januState = {...state, loading: false, radio_data: action.payload.radio_data}
                return januState
        case typesShipCli.GET_SHIP_CLI_BEGIN:
            console.log("loading")
            return {...state, error: false,loading: true}
        case typesShipCli.GET_SHIP_CLI_ERROR:
            console.log("error CRUISE INIT******SV **8MAR7** nodata or other ")
            //return {...state, error: true}
            return {...state,loading: false, hasMore:false, error: true}
        /*svmar14 start*/
        case "GET_META_FLY_SUCCESS":
            console.log("reduce %%%%%%%%evclisearch my_data_meta Mar14 reducer  success*****************");
            console.log(action.payload.my_data_meta);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            if(action.payload.my_data_meta){
                januState = {...state, error: false, loading: false,  my_data_meta: action.payload.my_data_meta}

            }else{
                console.log('meta data undfined');   
            }
                       return januState
        case typesShipCli.GET_META_FLY_BEGIN:
            console.log("loading")
            return {...state, error: false,loading: true}
        case typesShipCli.GET_META_FLY_ERROR:
            console.log("error")
            return {...state, error: true}
        /*svmar14 end*/
       
        default:
            return state
    }
}